import styled from 'styled-components';

export const UserInformationPanelStyled = styled.table`
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
`;
